import styled from 'styled-components';
import { Tabs } from 'antd';

export const TabsWrapper = styled(Tabs)`
  // 상위에서 glober 스타일 조정으로 && 사용
  &.ant-tabs {
    width: 100%;
    margin-top: 5.7rem;

    .ant-tabs-nav-list {
      width: 100%;
    }
    .ant-tabs-tab {
      width: 100%;
      justify-content: center;
    }
    .ant-tabs-tab + .ant-tabs-tab {
      margin: 0;
    }
  }
`;

export const CertificationInputWrapper = styled.div`
  &&& {
    display: flex;
    gap: 8px;
    align-items: end;

    .field.form-input {
      width: 100%;
      margin: 0px;
    }
  }
`;

export const FormContentWrapper = styled.div`
  .title {
    margin-top: 5.6rem;
    font-size: 24px;
    font-weight: 700;
    line-height: 24px;
    color: #000000;
  }
  .sub-title {
    margin-top: 4px;
    margin-bottom: 2.92rem;
    font-size: 15px;
    line-height: 22px;
    letter-spacing: -0.5px;
    color: #8a8c8d;
  }

  .content {
    margin-top: 2rem;
    .ant-statistic.count-down {
      .ant-statistic-content {
        position: absolute;
        top: 50%;
        right: 16px;
        transform: translate(0px, -50%);
        font-size: 14px;
        color: red;
      }
    }
    input[name='password']:not(:placeholder-shown),
    input[name='verificationPassword']:not(:placeholder-shown) {
      letter-spacing: -2.5px;
    }
  }
`;

export const SecurityWrapper = styled.div`
  position: absolute;
  top: 50%;
  right: 16px;
  transform: translate(0px, -50%);
  display: flex;
  align-items: center;
  gap: 16px;
  font-size: 12px;
  line-height: 15px;
  color: ${({ $isPasswordSecure, $isPassword }) => {
    const color = $isPasswordSecure ? 'green' : 'red';
    return $isPassword ? color : '#c7c7c7';
  }};

  span {
    font-size: 15px;
  }
`;
